import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { RDReadyLogo } from './RDReadyLogo';
const BLUE = '#2563EB';
const TEAL = '#0F9E8E';
const links = [{
  label: 'Home',
  to: '/'
}, {
  label: 'RD Exam',
  to: '/rd-exam'
}, {
  label: 'CNSC Exam',
  to: '/cnsc-exam'
}, {
  label: 'About Us',
  to: '/about'
}, {
  label: 'Contact',
  to: '/contact'
}];
export function RDReadyNav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const {
    user
  } = useAuth();
  return <header className="sticky top-0 z-50 border-b border-[#EDF1F7] bg-white/95 backdrop-blur" style={{
    fontFamily: '"Poppins", "Inter", system-ui, sans-serif'
  }} data-id="element-3760">
      <div className="mx-auto flex h-18 max-w-7xl items-center justify-between px-5 py-3 md:px-8" data-id="element-3761">
        <Link to="/" className="shrink-0" aria-label="RD Ready home" data-id="element-3762">
          <RDReadyLogo className="h-8 w-36 sm:h-9 sm:w-40" data-id="element-3763" />
        </Link>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="Primary navigation" data-id="element-3764">
          {links.map(link => <Link key={link.label} to={link.to} className="text-sm font-medium text-[#475569] transition-colors hover:text-[#2563EB]" data-id="element-3765">
              {link.label}
            </Link>)}
        </nav>

        <div className="hidden items-center gap-4 lg:flex" data-id="element-3766">
          <Link to={user ? '/account' : '/login'} className="text-sm font-medium text-[#475569] transition-colors hover:text-[#2563EB]" data-id="element-3767">
            {user ? 'Account' : 'Sign in'}
          </Link>
          <Link to="/cnsc-prep" className="rounded-full px-6 py-2.5 text-sm font-semibold text-white shadow-sm transition-transform hover:-translate-y-0.5" style={{
          backgroundColor: BLUE
        }} data-id="element-3768">
            Get Started
          </Link>
        </div>

        <button type="button" onClick={() => setMenuOpen(open => !open)} className="p-2 text-[#0F172A] lg:hidden" aria-label={menuOpen ? 'Close navigation' : 'Open navigation'} aria-expanded={menuOpen} data-id="element-3769">
          {menuOpen ? <XIcon className="h-6 w-6" data-id="element-3770" /> : <MenuIcon className="h-6 w-6" data-id="element-3771" />}
        </button>
      </div>

      {menuOpen && <nav className="border-t border-[#EDF1F7] bg-white px-5 py-4 lg:hidden" aria-label="Mobile navigation" data-id="element-3772">
          <div className="mx-auto flex max-w-7xl flex-col" data-id="element-3773">
            {links.map(link => <Link key={link.label} to={link.to} onClick={() => setMenuOpen(false)} className="border-b border-[#F1F5F9] py-3.5 text-sm font-medium text-[#334155]" data-id="element-3774">
                {link.label}
              </Link>)}
            <Link to={user ? '/account' : '/login'} onClick={() => setMenuOpen(false)} className="border-b border-[#F1F5F9] py-3.5 text-sm font-medium text-[#334155]" data-id="element-3775">
              {user ? 'Account' : 'Sign in'}
            </Link>
            <Link to="/cnsc-prep" onClick={() => setMenuOpen(false)} className="mt-4 rounded-full px-5 py-3 text-center text-sm font-semibold text-white" style={{
          backgroundColor: BLUE
        }} data-id="element-3776">
              Get Started
            </Link>
          </div>
        </nav>}
    </header>;
}